VP = window.VP || {};

(function( $ ) {
	VP.relatedContent = {
		init: function () {
			var _this = this;

			if( $( 'div' ).hasClass( 'js-tabs' ) ){
				_this.buildTab();
			}

			return false;
		},

		buildTab: function() {
			var _this = this;
			var _tabs = $( '.js-tabs' );
			var _tabControl = $( '.vp-related-content__tablist a' );
			var _tabContent = $( '.js-tabs__panel' );
			var _firstTab = document.querySelector( '.vp-related-content__tablist a' );
			var _firstPanel = document.querySelector( '.js-tabs__panel' );

			if ( $('ul').hasClass( 'vp-related-content__tablist' ) ) {
				_firstTab.classList.add( 'is-active' );
				_firstPanel.classList.add( 'is-active' );

				_tabControl.click( function(e) {

					e.preventDefault();

					_tabControl.removeClass( 'is-active' );
					$( this ).addClass( 'is-active' );


					_currentTarget = $( this ).attr( 'href' );
					_targetPanel = _currentTarget.substr(5);

					_tabContent.removeClass( 'is-active' );
					$( '#' + _targetPanel ).addClass( 'is-active' );

				} );
			}

		},
	};
})(jQuery);
